<div class="linked-companies-dialog">

  <div class="dialog-header">
    <div class="dialog-header-left">
      <mat-icon class="header-icon">domain</mat-icon>
      <div>
        <h2 mat-dialog-title class="dialog-title">Linked Companies</h2>
        <span class="dialog-subtitle" *ngIf="companies?.length">{{companies.length}} {{companies.length === 1 ? 'company' : 'companies'}} linked</span>
      </div>
    </div>
    <button mat-icon-button class="close-btn" (click)="onCancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="table-scroll">
      <table mat-table matSort (matSortChange)="sortData($event)" [dataSource]="companies" class="linked-table" *ngIf="companies?.length">

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Entity Code</th>
          <td mat-cell *matCellDef="let element"><span class="code-chip">{{element.code}}</span></td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Entity Name</th>
          <td mat-cell *matCellDef="let element">{{element.name}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="companyColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: companyColumns;"></tr>
      </table>

      <div class="no-data" *ngIf="!companies?.length">
        <mat-icon>inbox</mat-icon>
        <span>No linked companies found.</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button class="cancel-btn" (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>

</div>
